import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["disabled", "onClick", "internalValue", "setInternalValue", "setInitialSelection", "onSelect", "onChange", "internalOptions", "options", "isFlat", "multiple", "onRenderSelectedValue", "tagLabelMaxLength", "openTagsCount", "renderAggregatedTagsLabel", "singleLine"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useCallback, useMemo, useRef, useState } from 'react';
import { noop, stringEllipsisAtMaxCharacters, useOnValueUpdate } from '../../../utils';
import { useSelectedTagsToDisplay } from './useSelectedTagsToDisplay';
import { useOnToggleAll } from './useOnToggleAll';
import { useOnRemoveMultiple } from './useOnRemoveMultiple';
import { useOnPopulateTagsAutomatically } from './useOnPopulateTagsAutomatically';
import { useRootRef } from '../../../system';
export var useDropdownBeforeSection = function useDropdownBeforeSection(_ref, ref) {
  var disabled = _ref.disabled,
      onClick = _ref.onClick,
      internalValue = _ref.internalValue,
      setInternalValue = _ref.setInternalValue,
      setInitialSelection = _ref.setInitialSelection,
      onSelect = _ref.onSelect,
      onChange = _ref.onChange,
      internalOptions = _ref.internalOptions,
      options = _ref.options,
      isFlat = _ref.isFlat,
      multiple = _ref.multiple,
      onRenderSelectedValue = _ref.onRenderSelectedValue,
      tagLabelMaxLength = _ref.tagLabelMaxLength,
      _ref$openTagsCount = _ref.openTagsCount,
      openTagsCount = _ref$openTagsCount === void 0 ? 1 : _ref$openTagsCount,
      renderAggregatedTagsLabel = _ref.renderAggregatedTagsLabel,
      singleLine = _ref.singleLine,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var containerRef = useRootRef(ref);
  var beforeSectionContainerRef = useRef(null);
  var beforeSectionWrapperRef = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isMaxWidthReached = _useState2[0],
      setIsMaxWidthReached = _useState2[1];

  var _useState3 = useState(singleLine ? 1 : openTagsCount),
      _useState4 = _slicedToArray(_useState3, 2),
      internalOpenTagsCount = _useState4[0],
      setInternalOpenTagsCount = _useState4[1];

  var selectedTagsToDisplay = useSelectedTagsToDisplay(internalValue, internalOptions);
  var onValueUpdate = useOnValueUpdate(setInternalValue, onSelect, onChange);
  var onToggleAll = useOnToggleAll(setInternalValue, internalOptions, internalValue, onChange, setInitialSelection);
  var onRemoveMultiple = useOnRemoveMultiple(setInternalValue, internalValue, onChange);
  useOnPopulateTagsAutomatically(selectedTagsToDisplay, beforeSectionContainerRef, beforeSectionWrapperRef, isMaxWidthReached, setIsMaxWidthReached, internalOpenTagsCount, setInternalOpenTagsCount, singleLine);
  var handleRemoveAllTags = useMemo(function () {
    return disabled ? noop : function (event) {
      event.stopPropagation();
      onToggleAll(false);
    };
  }, [disabled]);

  var handleRemoveTag = function handleRemoveTag(option) {
    return function () {
      return onValueUpdate(internalValue, multiple, option, option.value, options, isFlat);
    };
  };

  var handleRemoveRemainingTags = function handleRemoveRemainingTags(tagValuesToRemove) {
    return function () {
      return onRemoveMultiple(tagValuesToRemove);
    };
  };

  var getAggregatedTagsLabel = useCallback(function (remainingItemsCount) {
    if (renderAggregatedTagsLabel) {
      return renderAggregatedTagsLabel(remainingItemsCount);
    }

    return "+".concat(remainingItemsCount, " item").concat(remainingItemsCount === 1 ? '' : 's');
  }, [renderAggregatedTagsLabel]);
  return {
    rootProps: _objectSpread(_objectSpread({}, restProps), {}, {
      onClick: onClick,
      disabled: disabled,
      ref: containerRef,
      singleLine: singleLine
    }),
    beforeSectionClearButtonProps: {
      disabled: disabled,
      onClick: handleRemoveAllTags
    },
    getDropdownTagProps: function getDropdownTagProps(option) {
      var label = option.label;

      if (typeof label === 'string' || typeof label === 'number') {
        label = stringEllipsisAtMaxCharacters(option.label.toString(), tagLabelMaxLength);
      }

      return {
        deleteOption: 'enabled',
        disabled: disabled,
        label: label,
        onClose: handleRemoveTag(option),
        key: option.value
      };
    },
    getDropdownRemainingTagsProps: function getDropdownRemainingTagsProps(remainingItemsCount, tagsValues) {
      return {
        key: 'remaining_items',
        disabled: disabled,
        label: getAggregatedTagsLabel(remainingItemsCount),
        onClose: handleRemoveRemainingTags(tagsValues)
      };
    },
    dropdownBeforeSectionTagsContainerProps: {
      ref: beforeSectionContainerRef
    },
    dropdownBeforeSectionTagsWrapperProps: {
      ref: beforeSectionWrapperRef
    },
    dropdownTagsProps: {
      disabled: disabled,
      key: 'expanded_tags'
    },
    disabled: disabled,
    isBeforeSectionRendered: multiple && !onRenderSelectedValue,
    selectedTagsToDisplay: selectedTagsToDisplay,
    internalOpenTagsCount: internalOpenTagsCount
  };
};